import TagTypeIcon from '@material-ui/icons/Label'
import List from './List'
import Create from './Create'
import Edit from './Edit'

export default {
  list: List,
  edit: Edit,
  show: Edit,
  create: Create,
  icon: TagTypeIcon,
}

